import { render, staticRenderFns } from "./join_form.vue?vue&type=template&id=303f534e&scoped=true"
import script from "./join_form.vue?vue&type=script&lang=js"
export * from "./join_form.vue?vue&type=script&lang=js"
import style0 from "./join_form.vue?vue&type=style&index=0&id=303f534e&lang=css"
import style1 from "./join_form.vue?vue&type=style&index=1&id=303f534e&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303f534e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('303f534e')) {
      api.createRecord('303f534e', component.options)
    } else {
      api.reload('303f534e', component.options)
    }
    module.hot.accept("./join_form.vue?vue&type=template&id=303f534e&scoped=true", function () {
      api.rerender('303f534e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/join_form.vue"
export default component.exports